import { HomeworkAPI } from '../../path/homework';
import { fetchData } from '@umu/umu-fetch';
import { IResponse } from '@umu/umu-types';

export interface IOutput {
    result: boolean;
}

interface IInput {
    homework_id: number;
    is_shield: number;
}


export const switchHomeworkShield = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(HomeworkAPI.POST_SWITCH_HOMEWORK_SHIELD, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
